/* eslint no-eval: 0 */

import React from 'react';
import {_GPY} from '../../../env.js'
import TimerText from './TimerText.js'
import DataText from './DataText.js'


class Bolw extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      data  : undefined,
      numberData: 0,
      booleanData: false,
      overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{},
      transition : "transition-start" ,
      timerIsActive: false,
      eventListener:{},
      data: [new Array(new Array())],
      currentPlayerId : 112,
    };
  }

  registDataListener(name,listener) {
    var l = this.state.eventListener;
    l[name] = listener;
    this.setState({"eventListener":l});
  }

  onSetTimeout(){
    console.log(this.props.stateName+" onSetTimeout");
  }

  onInit(overlayConfig){
    this.setState({transition: this.state.overlayConfig.transition +"-leave"})
  }


  onData (data,key) {
    if(key==="Bowling_player_result") {
      console.log("Bowling_player_result",data);
        this.setState({data:data});
    } else {
    if(typeof data === 'object') {

      if( data.visible ) {
        if(data.result===undefined){
          this.setState({active: data.visible, transition: this.state.overlayConfig.transition +"-active"});
        }else{
          this.setState({active: data.visible, data:data.result, transition: this.state.overlayConfig.transition +"-active"});
        }
      } else {
        this.setState({active: data.visible, transition: this.state.overlayConfig.transition +"-leave"});
      }
    } else if( typeof data === 'number' ) {
        this.setState({numberData: data});
    } else if(typeof data === 'boolean') {
        this.setState({booleanData: data});
    }
    }
  }

  sortProperties(obj) {
    var sortable=[];
	  for(var key in obj) {
		    if(obj.hasOwnProperty(key)) {
			     sortable.push([key, obj[key]]);
           sortable.sort(function(a, b) {
          //    console.log(a[1].element.zindex , b[1].element.zindex);
			         return b[1].element.zindex - a[1].element.zindex;
		       });
        }
    }
	  return sortable;
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
    if(this.props.readAlong !== undefined) {
      var readAlongs = this.props.readAlong.split("|");
      for (var r in readAlongs){
          this.props.display.registDataListener(readAlongs[r],this);
      }
    }
    if(this.props.display.state.gameStates[this.props.stateName]!==undefined) {
      this.onData(this.props.display.state.gameStates[this.props.stateName],this.props.stateName);
    }
  }

  render() {
    /*
    if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined) {
      return (<div className={this.state.transition}/>);
    }
   */

   var sy = {position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%'};
   if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined){
     sy = {display:"none", position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%'};
   }

    var elements = this.state.overlayConfig.elements;
    var counter = 0;
    return (
        <div className={this.state.transition} style={sy}>

         {this.sortProperties(elements).map(([key,element],i) => {
            counter++;
            var e = element.element;
            var k = e.elementType+"_"+e.dataSource+"_"+counter;
            if (!e.enable) {
              return ("");
            }

            var items = [1,2,3,4,5,6,7,8,9,10,11];

            if(e.elementType === "image" && e.imageSrc !== undefined && e.imageSrc !== '') {
              return (
                <div>
                  <div key={k} style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                    <img alt="" className="image-fluid" style={{maxWidth: e.width + "px", maxHeight :e.height+"px"}}
                    src={_GPY.resource("upload/" + e.imageSrc )} />
                  </div>

                  <div key={k+"_ov"} style={{ position : "absolute", opacity: e.opacity, left : e.x+"px", top :  e.y+"px", width : e.width+"px", height : e.height+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>

                  { items.map( (i) => {
                    return (<div key={k+i+"e"} style={{ position : "absolute", opacity: e.opacity, left : 10 + Math.floor( (Math.floor((e.width-20)/11) * (i-1) ) )+ "px", top : 0+"px", width : Math.floor((e.width-20)/11)+"px", height : (e.height/2)+"px", display: "flex", alignItems: e.valign, justifyContent: e.align }}>
                      <span style={{color:"#fff", fontSize:25+"px"}}>{i===11?"Score":i}</span>
                    </div>
                    );
                  })}

                  { items.map( (i) => {

                    return (<div key={k+i+"f"} style={{ border: "1px #fff solid", position : "absolute", opacity: e.opacity, left : 10 + Math.floor( (Math.floor((e.width-20)/11) * (i-1) ) )+ "px", top : 35+"px", width : Math.floor((e.width-20)/11)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>

                    {i===10?
                      <div>
                        <div key={k+i+"a"} style={{ position : "absolute", left :  0+ "px", top : 0+"px", width : Math.floor(((e.width-20)/11)/3)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? "" :  this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][0]>0?this.state.data[i][0]===10?"X":this.state.data[i][0]:""}</span>
                        </div>

                        <div key={k+i+"B"} style={{ borderLeft: i===11?"0px":"1px #fff solid", position : "absolute", left :  Math.floor(((e.width-20)/11)/3) + "px", top : 0+"px", width : Math.floor(((e.width-20)/11)/3)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? "" :   this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][1]>0?this.state.data[i][1]+this.state.data[i][0]===10?"/":this.state.data[i][1]:""}</span>
                        </div>

                        <div key={k+i+"rr"} style={{ borderLeft: i===11?"0px":"1px #fff solid", position : "absolute", left :  Math.floor(((e.width-20)/11)/3)*2+ "px", top : 0+"px", width : Math.floor(((e.width-20)/11)/3)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? "" : this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][2]>0?this.state.data[i][2]===10?"X":this.state.data[i][2]:""}</span>
                        </div>
                        </div>
:
  <div>
<div key={k+i+"a"} style={{ position : "absolute", left :  0+ "px", top : 0+"px", width : Math.floor(((e.width-20)/11)/2)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? "" :  this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][0]>0?this.state.data[i][0]===10?"":this.state.data[i][0]:""}</span>
</div>

<div key={k+i+"B"} style={{ borderLeft: i===11?"0px":"1px #fff solid", position : "absolute", left :  Math.floor(((e.width-20)/11)/2)+ "px", top : 0+"px", width : Math.floor(((e.width-20)/11)/2)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? "" : this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][0]===10?"X" : this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][1]>0?this.state.data[i][1]+this.state.data[i][0]===10?"/":this.state.data[i][1]:""}</span>
</div>

  </div>

}
                    </div>
                    );
                  })}

                  { items.map( (i) => {

                    return (<div key={k+i+"C"} style={{ border: "1px #fff solid", position : "absolute", opacity: e.opacity, left : 10 + Math.floor( (Math.floor((e.width-20)/11) * (i-1) ) )+ "px", top : 25+((e.height-35)/2)+"px", width : Math.floor((e.width-20)/11)+"px", height : ((e.height-35)/2)-10+"px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <span style={{color:"#fff", fontSize:40+"px"}}>{i===11 ? this.state.data!==undefined&&this.state.data[0]!==undefined?this.state.data[0]:""    :  this.state.data!==undefined&&this.state.data[i]!==undefined&&this.state.data[i][4]>0?this.state.data[i][4]:""}</span>
                    </div>
                    );
                  })}


                  </div>

               </div>
              );
            }

          }
         )}
        </div>
    );
  }
}
export default Bolw;
